module.exports = __webpack_public_path__ + "static/Abbotsford6-578d3b3b4c4f31144c63d5b245afcae2.jpg";